export default __webpack_public_path__ + "assets/Tulum.199e1da5.png";